import React from 'react';
import { motion } from 'framer-motion';
import { PlayCircle, Handshake } from 'lucide-react';
import { InteriorSlide, SlideHeader, SlideBanner } from './SlideShell';
import type { SlideProps } from './SlideShell';
export function Slide11Actions({
  index
}: SlideProps) {
  return <InteriorSlide surface banner={<SlideBanner eyebrow="The Offer" data-id="element-241">
          One partner. Four brands. The whole continent.
        </SlideBanner>} data-id="element-240">
      <SlideHeader eyebrow="Next Steps" data-id="element-242">Let's Start This Week</SlideHeader>

      <div className="flex-1 flex flex-col justify-center max-w-5xl mx-auto w-full gap-8" data-id="element-243">
        <motion.p initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.3,
        duration: 0.5
      }} className="text-[clamp(1.2rem,1.5vw,1.4rem)] text-[var(--fg)] font-bold text-center mb-4" data-id="element-244">
          Two simple decisions.
        </motion.p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-245">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: 0.4,
          duration: 0.6
        }} className="bg-white rounded-3xl shadow-sm border border-black/5 p-8 flex flex-col" data-id="element-246">
            <div className="flex items-center gap-4 mb-6" data-id="element-247">
              <div className="h-12 w-12 rounded-full bg-[var(--brand)] text-white flex items-center justify-center font-bold text-xl" data-id="element-248">
                1
              </div>
              <h3 className="text-2xl font-bold text-[var(--fg)]" data-id="element-249">
                Fix Phesgo — €3,500
              </h3>
            </div>
            <p className="text-[var(--muted)] leading-relaxed mb-6" data-id="element-250">
              Greenlight us on the three immediate improvements. We start this
              week. You'll see results within 30 days.
            </p>
            <ul className="space-y-3 mt-auto" data-id="element-251">
              <li className="flex items-center gap-3 text-sm font-semibold text-[var(--fg)]" data-id="element-252">
                <PlayCircle className="h-4 w-4 text-[var(--brand)]" data-id="element-253" /> QR →
                Trailer bridge
              </li>
              <li className="flex items-center gap-3 text-sm font-semibold text-[var(--fg)]" data-id="element-254">
                <PlayCircle className="h-4 w-4 text-[var(--brand)]" data-id="element-255" /> Post-quiz
                follow-up fork
              </li>
              <li className="flex items-center gap-3 text-sm font-semibold text-[var(--fg)]" data-id="element-256">
                <PlayCircle className="h-4 w-4 text-[var(--brand)]" data-id="element-257" /> Direct
                email blast to trailer
              </li>
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: 0.5,
          duration: 0.6
        }} className="bg-white rounded-3xl shadow-sm border border-black/5 p-8 flex flex-col" data-id="element-258">
            <div className="flex items-center gap-4 mb-6" data-id="element-259">
              <div className="h-12 w-12 rounded-full bg-[var(--brand-light)] text-white flex items-center justify-center font-bold text-xl" data-id="element-260">
                2
              </div>
              <h3 className="text-2xl font-bold text-[var(--fg)]" data-id="element-261">
                Start the Partnership Conversation
              </h3>
            </div>
            <p className="text-[var(--muted)] leading-relaxed mb-6" data-id="element-262">
              Tell us which brands you want to start with. We'll propose a
              campaign plan for each — and introduce you to what a full Snakker
              Africa partnership looks like.
            </p>
            <ul className="space-y-3 mt-auto" data-id="element-263">
              <li className="flex items-center gap-3 text-sm font-semibold text-[var(--fg)]" data-id="element-264">
                <Handshake className="h-4 w-4 text-[var(--brand)]" data-id="element-265" /> Phesgo
                (Breast Cancer)
              </li>
              <li className="flex items-center gap-3 text-sm font-semibold text-[var(--fg)]" data-id="element-266">
                <Handshake className="h-4 w-4 text-[var(--brand)]" data-id="element-267" /> MS /
                Ophthalmology / Hemophilia
              </li>
              <li className="flex items-center gap-3 text-sm font-semibold text-[var(--fg)]" data-id="element-268">
                <Handshake className="h-4 w-4 text-[var(--brand)]" data-id="element-269" />{' '}
                Localization for priority countries
              </li>
            </ul>
          </motion.div>
        </div>
      </div>
    </InteriorSlide>;
}